// extracted by mini-css-extract-plugin
export default {"spinnerWrap":"Spinner_spinnerWrap__f3h+a","spinner":"Spinner_spinner__zQ0lB","spin":"Spinner_spin__rm97J","srOnly":"Spinner_srOnly__0E9zl"};